module.exports = __webpack_public_path__ + "img/creativevalley.a13a3e3f.png";